<template>
    <div class="float-left mr-1">
        <b-button
            variant="primary"
            @click.stop="abrirModalInserirItem()"
            :disabled="desativarBotao"
        >
            <span> <i class="fa fa-plus mr-2"></i> Adicionar Item </span>
        </b-button>
        <b-modal id="modalInserirSubItem" v-model="mostrarModalInserirItem">
            <div slot="modal-title">
                Item do Contrato -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição Resumida</label>
                        <b-form-textarea
                            v-model="descricaoResumida"
                            :rows="4"
                            :maxlength="200"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Quantidade</label>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row> -->
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalInserirItem()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="adicionarItemContrato()"
                    class="ml-1"
                    >Inserir</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        desativarBotao: Boolean
    },

    data() {
        return {
            itemContrato: {},
            descricao: '',
            descricaoResumida: '',
            valor: 0,
            quantidade: 0,
            mostrarModalInserirItem: false,
            operacao: 'INSERÇÃO',
            erros: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            }
        }
    },

    methods: {
        abrirModalInserirItem() {
            this.mostrarModalInserirItem = true
        },

        fecharModalInserirItem() {
            this.resetInserirItem()
            this.mostrarModalInserirItem = false
        },

        resetInserirItem() {
            this.descricao = ''
            this.descricaoResumida = ''
            this.valor = 0
            this.quantidade = 0
            ;(this.erros = []),
                (this.itemContrato = {}),
                this.$nextTick(() => {
                    this.$v.$reset()
                })
        },

        adicionarItemContrato() {
            this.itemContrato.descricao = this.descricao
            this.itemContrato.descricaoResumida = this.descricaoResumida
            this.itemContrato.valorUnitario = this.valor
            this.itemContrato.quantidade = this.quantidade
            this.itemContrato.status = 1
            this.itemContrato.ordem = 1
            this.itemContrato.saldoValor = this.valor
            this.itemContrato.saldoQuantidade = this.quantidade
            this.itemContrato.seqRM = 0
            this.itemContrato.nuTipoAditivo = 0

            this.$emit('salvarItemContrato', this.itemContrato)

            this.fecharModalInserirItem()
        }
    },

    created() {},

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {},

    validations: {
        descricao: {
            required
        },
        valor: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
